"use client";

import { useEffect, useRef } from "react";
import posthog from "posthog-js";

interface ProductViewedTrackerProps {
	productName: string;
	productSlug: string;
	category?: string | null;
	channel: string;
	priceAmount?: number | null;
	currency?: string | null;
}

export function ProductViewedTracker(props: ProductViewedTrackerProps) {
	const lastView = useRef<string | null>(null);

	useEffect(() => {
		if (!posthog.__loaded || posthog.has_opted_out_capturing()) return;
		const key = JSON.stringify([props.productSlug, props.channel]);
		if (lastView.current === key) return;
		lastView.current = key;
		posthog.capture("product_viewed", {
			product_name: props.productName,
			product_slug: props.productSlug,
			category: props.category ?? undefined,
			channel: props.channel,
			price: props.priceAmount ?? undefined,
			currency: props.currency ?? undefined,
		});
	}, [props]);

	return null;
}
